import { values } from '@fortem-monorepo/js-utilities';
export const ASSET_CLASS = {
    Agf: 'AGF',
    Amc: 'AMC',
    Alternative: 'Alternative',
    AssetSwap: 'Asset Swap',
    Benchmark: 'Benchmark',
    CdsHedge: 'CDSHedge',
    Commodity: 'Commodity',
    CommodityVolatility: 'Commodity Volatility',
    CommonStock: 'Common Stock',
    Credit: 'Credit',
    CrossAsset: 'Cross-Asset',
    Dgf: 'DGF',
    Diversifier: 'Diversifier',
    Equity: 'Equity',
    EuropeanEquityVolArb: 'European Equity Vol Arb',
    Fx: 'FX',
    Gold: 'Gold',
    Growth: 'Growth',
    HedgeFund: 'Hedge Fund',
    Income: 'Income',
    Property: 'Property',
    PutHedge: 'PutHedge',
    Rate: 'Rate',
    Rates: 'Rates',
    SptrIndex: 'SPTR Index',
    UsEquityVolArb: 'US Equity Vol Arb',
};
export const ASSET_CLASSES = values(ASSET_CLASS);
